<div class="column serving">
    <div class="cell" [class.possession-icon]="isPossessionIconEnabled">
        @if (score.currentlyServing === 1) {
            <span class="{{ icon }}"></span>
        }
    </div>
    <div class="cell" [class.possession-icon]="isPossessionIconEnabled">
        @if (score.currentlyServing === 2) {
            <span class="{{ icon }}"></span>
        }
    </div>
</div>

@if (points) {
    <div class="column points">
        <div class="cell">
            <div [msValueSlider]="points.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="points.participant2.toString()"></div>
        </div>
        @if (!hideScoreBoardColumnFooter) {
            <div class="cell">{{ sitecore.eventGrid.Scoreboard_P }}</div>
        }
    </div>
}
@if (games) {
    <div class="column games divider">
        <div class="cell">
            <div [msValueSlider]="games.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="games.participant2.toString()"></div>
        </div>
        @if (points && !hideScoreBoardColumnFooter) {
            <div class="cell">{{ sitecore.eventGrid.Scoreboard_G }}</div>
        }
    </div>
}
@if (sets) {
    <div class="column sets">
        <div class="cell">
            <div [msValueSlider]="sets.participant1.toString()"></div>
        </div>
        <div class="cell">
            <div [msValueSlider]="sets.participant2.toString()"></div>
        </div>
        @if (!hideScoreBoardColumnFooter) {
            <div class="cell">{{ sitecore.eventGrid.ScoreboardSets }}</div>
        }
    </div>
}
